<section>
    <router-outlet></router-outlet>
</section>
<greyout></greyout>